import log = require("loglevel");

log.setLevel(LogLevel.INFO);

export default log;


/** WEBPACK FOOTER **
 ** ./src/Logger.ts
 **/